import styled, { css } from 'styled-components';
import { BREAKPOINTS, COLORS } from './variables';

export const H1Style = css`
  font-family: Lora;
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: inherit;
  @media ${BREAKPOINTS.laptop} {
    font-size: 3.43vw;
  }
  @media ${BREAKPOINTS.mobile} {
    font-size: 4.58vw;
  }
`;

export const H2Style = css`
  font-family: Lora;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: inherit;
  text-align: center;
  @media ${BREAKPOINTS.laptop} {
    font-size: 1.71vw;
  }
  @media ${BREAKPOINTS.mobile} {
    font-size: 4.17vw;
  }
`;

export const P1Style = css`
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: inherit;
  @media ${BREAKPOINTS.laptop} {
    font-size: 1.29vw;
  }
  @media ${BREAKPOINTS.mobile} {
    font-size: 3.75vw;
  }
`;

export const P2Style = css`
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 135%;
  color: inherit;
  @media ${BREAKPOINTS.laptop} {
    font-size: 1.29vw;
  }
  @media ${BREAKPOINTS.mobile} {
    font-size: 3.33vw;
    line-height: normal;
  }
`;

export const ButtonTextStyle = css`
  font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  color: inherit;
  @media ${BREAKPOINTS.laptop} {
    font-size: 1.43vw;
    line-height: 1.29vw;
  }
  @media ${BREAKPOINTS.mobile} {
    font-size: 3.33vw;
    line-height: 3.75vw;
  }
`;

export const H1 = styled.h1`
  ${H1Style};
`;

export const H2 = styled.h2`
  ${H2Style};
`;

export const P1 = styled.p`
  ${P1Style};
`;

export const P2 = styled.p`
  ${P2Style};
`;

export const ButtonLink = styled.a`
  ${ButtonTextStyle};
  cursor: pointer;
  text-align: center;
  padding: 18px 70px;
  border-radius: 28px;

  background-color: ${COLORS.orange};
  transition: 0.2s;
  &:hover {
    background-color: ${COLORS.darkOrange};
  }
  &:active {
    background-color: ${COLORS.brown};
  }
  @media ${BREAKPOINTS.laptop} {
    padding: 1.29vw 5vw;
    border-radius: 2vw;
  }
  @media ${BREAKPOINTS.mobile} {
    padding: 2.5vw 5.83vw;
    border-radius: 5vw;
  }
`;

export const ContentWr = styled.div`
  flex-grow: 1;
  width: 100%;

  padding: 20px 100px;
  position: relative;
  @media ${BREAKPOINTS.laptop} {
    padding: 1.43vw 7.14vw;
  }
  @media ${BREAKPOINTS.mobile} {
    padding: 5.83vw 8.75vw;
  }
`;
